import { z } from 'zod';

import { apiClient } from './client';

export const TrustPassportZ = z.object({
  user_id: z.number().int(),
  score: z.number().int().nullable(),
  credit_score: z.number().int().nullable().optional(),
  lease_history_count: z.number().int().optional(),
  on_time_payment_rate: z.number().optional(),
  last_check_at: z.string().nullable().optional(),
  rating: z.enum(['excellent', 'good', 'average', 'poor']).nullable().optional(),
});
export type TrustPassport = z.infer<typeof TrustPassportZ>;

const ResourceZ = z.object({ data: TrustPassportZ });

export async function getTrustPassport(): Promise<TrustPassport> {
  // backend routes -- /trust-passport/me и /me/refresh (не /trust-passport[/refresh]).
  const res = await apiClient.get('/trust-passport/me');
  return ResourceZ.parse(res.data).data;
}

export async function refreshTrustPassport(): Promise<TrustPassport> {
  const res = await apiClient.post('/trust-passport/me/refresh');
  return ResourceZ.parse(res.data).data;
}

export const trustPassportApi = { get: getTrustPassport, refresh: refreshTrustPassport };
